import React from "react";
import { launchModal } from "MODULES/shared/decorators";
import ModalLauncher from "MODULES/shared/containers/ModalLauncher";
import PayAll from "./PayAll";

class PayAllCommissions extends ModalLauncher {
  static defaultProps = {
    text: "Pay All",
    buttonClass: "btn-info"
  };

  render() {
    return <span className="input-group-btn">{this.button()};</span>;
  }
}

export default launchModal(
  (open, close) => <PayAll open={open} close={close} />,
  PayAllCommissions
);



// WEBPACK FOOTER //
// ./app/modules/Commissions/components/PayAll/OpenPayAll.jsx